/** @jsxImportSource minimal-view */

import { element, part, view, web } from 'minimal-view'
import { skin } from './skin'
import { hmr } from './hmr'
import { audio } from './audio'
import { AsciiSvg } from './util/ascii-svg'
import { classes } from './util/classes'
import { app } from './app'

export type Transport = typeof Transport.State

export const Transport = hmr(view('transport',
  class props {
  },
  class local {
    // host = element
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
    })
  },
  function effects({ $, fx, deps, refs }) {
    fx(() => skin.fx(({ fonts, colors }) => {
      $.css = /*css*/`
      & {
      }
      `
    }))

    const LiveToggle = part((update) => {
      app.fx(({ live }) => {
        localStorage.live = live ? 'on' : ''
        update(
          <button title={"toggle live\nctrl/cmd+enter: compile"} class={classes({ active: live })} onpointerdown={() => {
            app.$.live = !app.$.live
          }}>
            <AsciiSvg lines={[[
              // '---',
              // '1--',
              // '---',
              // '---',
              // '---',
              // '---',
              // '---',
              // '--3',
              // '---',
              // '---',
              // '---',
              // '---',
              // '---',
              // '2--',
              // '---',

              // '---',
              // '1--',
              // '---',
              // '---',
              // '---',
              // '---',
              // '---',
              // '--3',
              // '---',
              // '---',
              // '---',
              // '---',
              // '---',
              // '2--',
              // '---',

              '----------------',
              '---1------------',
              '----------------',
              '----------------',
              '------------3---',
              '----------------',
              '----------------',
              '---2------------',
              '----------------',

              // '-----------',
              // '---1-------',
              // '-----------',
              // '-----------',
              // '-------3---',
              // '---2-------',
              // '-----------',
            ]]} />
          </button>
        )
      })
    })

    const StabilizeToggle = part((update) => {
      app.fx(({ stabilize }) => {
        localStorage.stabilize = stabilize ? 'on' : ''
        update(
          <button title="toggle stabilizer" class={classes({ active: stabilize })} onpointerdown={() => {
            app.$.stabilize = !app.$.stabilize
          }}>
            <AsciiSvg lines={[[
              // '--------',
              // '--------',
              // '--2--1--',
              // '--------',
              // '--------',
              // '--------',
              // '--------',
              // '--4--3--',
              // '--------',
              // '--------',

              '--------------',
              '----------1---',
              '--------------',
              '--------------',
              '--------------',
              '---2----------',
              '--------------',
              '--------------',
              '--------------',
              '----------3---',
              '--------------',
              '--------------',
              '--------------',
              '---4----------',
              '--------------',

              // '---------',
              // '----1----',
              // '---------',
              // '--2---3--',
              // '---------',
              // '----4----',
              // '---------',
            ]]} />
          </button>
        )
      })
    })

    const Save = part((update) => {
      app.fx(({ sound, edited, editedChk: _ }) => {
        update(
          edited.has(sound.id) ? <>
            <button onpointerdown={app.$.discard}
              title="discard edits"
              class={classes({
                discard: true
              })}>
              <AsciiSvg lines={[[
                '-------',
                '-1-----',
                '-------',
                '-------',
                '-------',
                '-----2-',
                '-------',
              ], [
                '-------',
                '-----2-',
                '-------',
                '-------',
                '-------',
                '-1-----',
                '-------',
              ]]} />
            </button>
            <button onpointerdown={app.$.save}
              title="save"
              class={classes({
                save: true,
                active: true
              })}>
              <AsciiSvg lines={[[
                '--1--',
                '-----',
                '-----',
                '-----',
                '--2--',
              ], [
                '-----',
                '-----',
                '1---2',
                '-----',
                '-----',
              ]]} />
            </button>
          </> : false
        )
      })
    })

    fx(() => audio.fx(({ dspl, isPlaying }) => {
      $.view =
        <div class="transport">
          <div>
            <button title={isPlaying ? 'replay' : 'play'} ontouchstart={audio.$.start} onpointerdown={audio.$.start} class={classes({
              active: isPlaying,
              play: true,
            })}>
              <AsciiSvg lines={[[
                '---',
                '1--',
                '---',
                '---',
                '---',
                '---',
                '---',
                '--2',
                '---',
                '---',
                '---',
                '---',
                '---',
                '3--',
                '---',
              ]]} connect />
            </button>

            <button title="stop" class="stop" ontouchstart={audio.$.stop} onpointerdown={audio.$.stop}>
              <AsciiSvg lines={[[
                '1-2',
                '---',
                '4-3',
              ]]} connect />
            </button>
            {/* <button onpointerdown={audio.$.reset}>
              <AsciiSvg lines={[[
                '--------',
                '-1----2-',
                '--------',
                '--------',
                '-4----3-',
                '--------',
                '--------',
                '-5------',
                '--------',
              ], [
                '--------',
                '-1------',
                '--------',
                '--------',
                '-2------',
                '--------',
                '--------',
                '------3-',
                '--------',
              ]]} />
            </button> */}
            <LiveToggle />
            <StabilizeToggle />
            <Save />
          </div>
          <div>
            <button title="about wavepot" onclick={() => { app.$.showAbout = true }}>
              <svg class="logo" width="32" height="32" viewBox="7 7 22 22">
                {/* <path class="pot" d="M 4.26 6.27 A 14.72 14.72 90 1 0 27.72 6.27" /> */}
                <path class="wave" d="M 8.52 14.91 Q 12.26 10.86 16 15.12 T 23.46 15.34" />
              </svg>
            </button>
          </div>
        </div>
    }))
  }
))
